import { UseContextReturn } from '~/types/core';
import type { SubscriptionStatusesEnum } from '~/modules/GraphQL/types';
import type { UseNewsletterUpdateSubscriptionParams } from '~/composables';
// eslint-disable-next-line import/no-extraneous-dependencies
import { GraphQLError } from 'graphql';

export const updateSubscriptionCommand = {
  // eslint-disable-next-line max-len
  execute: async (context: UseContextReturn, params: UseNewsletterUpdateSubscriptionParams): Promise<{ data: SubscriptionStatusesEnum; error: readonly GraphQLError[]; } | null> => {
    const { data, errors } = await context.app.$vsf.$magento.api.subscribeEmailToNewsletter({
      email: params.email,
    }, params?.customQuery ?? null, params?.customHeaders ?? null);
    return {
      data: data?.subscribeEmailToNewsletter?.status ?? null,
      error: errors || null,
    };
  },
};
